<template>
  <b-container>
    <div>
      <b-modal
        ref="openModal"
        class="filterDateModal"
        scrollable
        size="sm"
        title="Filtros para exportação"
        :ok-disabled="true"
        @ok="modalOk"
        @hide="hideModal"
      >
        <!-- ivan 2023-08-17 comentado por hora
        <div>
          <b-form-group
            :label="'Tipo de exportação'"
            :label-for="'Tipo de exportação'"
          >
            <b-form-select
              v-model="exportType"
              id="exportType"
              :options="exportTypeOpt"
            >
            </b-form-select>
          </b-form-group>
        </div> -->

        <div v-if="exportType == '1'">
          <b-form-group
            :label="'Template'"
            :label-for="'Template'"
            v-if="!showEdit"
          >
            <multiselect
              v-model="templateSelected"
              class="templateSelect1"
              label="text"
              track-by="value"
              :close-on-select="true"
              :showLabels="false"
              :multiple="false"
              :options="allTemplates"
              @input="showTemplateEdit"
            >
            </multiselect>
            <b-input-group-append>
              <b-button size="sm" class="addTemplate" @click="addNewTemplate()"
                ><i class="tim-icons icon-simple-add"></i
              ></b-button>
            </b-input-group-append>
          </b-form-group>
          <b-form-group
            :label="'Template'"
            :label-for="'Template'"
            v-if="showEdit"
          >
            <multiselect
              v-model="templateSelected"
              class="templateSelect2"
              label="text"
              track-by="value"
              :close-on-select="true"
              :showLabels="false"
              :multiple="false"
              :options="allTemplates"
              @input="showTemplateEdit"
            >
            </multiselect>
            <b-input-group-append>
              <b-button size="sm" class="editTemplate" @click="editTemplate()"
                ><i class="tim-icons icon-settings-gear-63"></i
              ></b-button>
              <b-button size="sm" class="addTemplate1" @click="addNewTemplate()"
                ><i class="tim-icons icon-simple-add"></i
              ></b-button>
            </b-input-group-append>
          </b-form-group>
        </div>

        <div v-for="field in fields" :key="field.key" class="vertical-align">
          <!-- {{field}} -->
          <div v-if="field.filterType == 'dateRangeCreate'">
            <b-form-group
              :label="field.label + ' (inicio)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters.dateCreateBegin"
              />
            </b-form-group>
            <b-form-group
              :label="field.label + ' (fim)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters.dateCreateEnd"
              />
            </b-form-group>
          </div>
          <div v-if="field.filterType == 'dateRangeApprovel'">
            <b-form-group
              :label="field.label + ' (inicio)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters.approvalDateBegin"
              />
            </b-form-group>
            <b-form-group
              :label="field.label + ' (fim)'"
              :label-for="field.filterKey"
            >
              <b-form-input
                :id="field.filterKey"
                type="date"
                v-model="tableFilters.approvalDateEnd"
              />
            </b-form-group>
          </div>

          <div v-else-if="tableFilters[field.filterKey] != null">
            <b-form-group :label="field.label" :label-for="field.filterKey">
              <b-form-input
                :id="field.filterKey"
                v-model="tableFilters[field.filterKey]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-form-group>
          </div>
        </div>
        <b-form-group
          label="Registros a exportar"
          label-for="paginationOptions"
        >
          <b-form-select
            v-model="paginationPerPage"
            id="paginationOptions"
            :options="paginationOptions"
          >
          </b-form-select>
        </b-form-group>
        <template #modal-footer="{ ok, cancel }">
          <div class="right">
            <b-button variant="green" @click="ok()" :disabled="isExporting">
              {{ $t("geral.confirm") }}
            </b-button>
            <b-button class="ml-2" variant="danger" @click="cancel()">
              {{ $t("geral.cancel") }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <!-- {{tableFilters}} -->
    <!-- {{ models }} -->
    <export-template-csv-create-modal
      ref="csvCreateTemplate"
      @refresh="getTemplates"
    ></export-template-csv-create-modal>
    <export-template-csv-edit-modal
      ref="csvEditTemplate"
      :id="templateId"
    ></export-template-csv-edit-modal>
    <b-row>
      <b-button size="sm" @click="modalOpen">Exportar Pendências</b-button>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "PendenciesExport",
  components: {
    ExportTemplateCsvCreateModal: () =>
      import(
        "@/components_rms/checklist/ExportTemplateCsv/ExportTemplateCsvCreateModal.vue"
      ),
    ExportTemplateCsvEditModal: () =>
      import(
        "@/components_rms/checklist/ExportTemplateCsv/ExportTemplateCsvEditModal.vue"
      ),
  },
  props: {
    fields: Array,
    tableFilters: Object,
    paginationPerPage: Number,
    pendencyStatus: Number,
  },
  data: function () {
    return {
      isExporting: false,
      paginationOptions: [5, 10, 25, 50, 100, 150, 500, 1000, 2500, 5000],
      exportTypeOpt: [
        { value: "0", text: "Padrão" },
        { value: "1", text: "Personalizada" },
      ],
      exportType: "0",
      allTemplates: [],
      templateId: "0",
      showEdit: false,
      formName: "",
      templateSelected: "",
    };
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
      this.getTemplates();
    },

    modalOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.tableFilters.pendencyStatus = this.pendencyStatus;
      this.tableFilters.perPage = this.paginationPerPage;
      this.tableFilters.currentPage = 1;
      this.tableFilters.exportType = this.exportType;
      this.tableFilters.templateId = this.templateId;

      this.isExporting = true;

      this.$apiChecklist
        .request({
          url: "/v2/checklist/pendencyExport/",
          method: "POST",
          data: this.tableFilters,
          responseType: "arraybuffer",
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isExporting = false;
          this.$refs.openModal.hide("modal-prevent-closing");
        });
    },
    getTemplates() {
      this.$apiChecklist
        .get("/exportTemplateCsv/templateDropdown/")
        .then((response) => {
          this.allTemplates = response.data;
          // this.refresh();
        });
    },
    addNewTemplate() {
      this.$refs.csvCreateTemplate.show();
    },
    editTemplate() {
      this.$refs.csvEditTemplate.show();
    },
    getFormName(templateId) {
      this.$apiChecklist
        .get("/exportTemplateCsv/getFormName/" + templateId)
        .then((response) => {
          this.tableFilters.formName = response.data;
          // this.refresh();
        });
    },

    showTemplateEdit(value) {
      this.templateId = value.value;
      this.showEdit = true;
      this.getFormName(value.value);
    },
    hideModal() {
      this.exportType = "0";
      this.templateId = "0";
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.addTemplate {
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
  height: 45px;
  margin-left: 85%;
  margin-top: -45px;
}
.addTemplate1 {
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
  height: 40px;
  margin-left: 88%;
  margin-top: -40px;
}
.editTemplate {
  border-top-left-radius: 0%;
  border-bottom-left-radius: 0%;
  border-top-right-radius: 0%;
  border-bottom-right-radius: 0%;
  height: 40px;
  margin-left: 72%;
  margin-top: -40px;
}
.templateSelect1 {
  width: 88%;
}
.templateSelect2 {
  width: 80%;
}
</style>
